import React from 'react'
import { css } from '@emotion/react'
import { ThemeProvider } from '@instacart/ids-core'
import { DesignWrapper } from '../../../containers/design-wrapper/DesignWrapper'
const designWrapperStorybookStyles = css({ padding: 100, minHeight: 300, minWidth: 300 })

export const DesignWrapperDecorator = (storyFn: Function) => (
  <ThemeProvider>
    <DesignWrapper styles={designWrapperStorybookStyles}>{storyFn()}</DesignWrapper>
  </ThemeProvider>
)
